import React from 'react';
import { StyledBroadsiderHudPopup } from './BroadsiderHudPopup.styled';
import { theme } from '../../theme';

const BroadsiderHudPopup = ({ children, bottomOffset = '0px', zIndex = 198, collapsed = false, overwrightWidth = null, overwrightMinWidth = null, disableScaling = false}) => {
  const width = overwrightWidth || `calc(50vw - ${theme.frameOffset})`;
  const right = overwrightWidth ? `calc((100vw - ${overwrightWidth}) / 2)` : '25vw';
  const minWidth = overwrightMinWidth || width;
  
  return (
    <StyledBroadsiderHudPopup $zindex={zIndex} $bottomOffset={bottomOffset} $right={right} $collapsed={collapsed} $width={width} $minWidth={minWidth} $disableScaling={disableScaling}>
      <div className='broadsider-hud-modal-content'>
      {children}
      <div className='broadsider-hud-modal-corner broadsider-hud-modal-corner-tl' />
      <div className='broadsider-hud-modal-corner broadsider-hud-modal-corner-tr' />
      <div className='broadsider-hud-modal-corner broadsider-hud-modal-corner-bl' />
      <div className='broadsider-hud-modal-corner broadsider-hud-modal-corner-br' />
      </div>
    </StyledBroadsiderHudPopup>
  );
};

export default BroadsiderHudPopup;
